import { css } from '@emotion/react'

export const upperCase = css`
  text-transform: uppercase;
`

export const lowerCase = css`
  text-transform: lowercase;
`

export const capitalize = css`
  text-transform: capitalize;
`
